<template>
  <div
    class="Delete"
    @click="$emit('close')"
  >
    <div
      class="delete-box"
      @click.stop
    >
      <img src="@/assets/images/logo.svg">
      <p>
        {{ $t('DISCIPLINE.DELETETEXT') }}
      </p>
      <div class="buttons">
        <BaseButton
          @click="$emit('deleteDiscpline')"
          @click.native="$emit('close')"
        >
          {{ $t('BUTTON.YES') }}
        </BaseButton>
        <BaseButton
          @click="$emit('close')"
        >
          {{ $t('BUTTON.NO') }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>

export default {


  data: () => ({
    error: false,
  }),
};
</script>

<style lang="scss" scoped>
.Delete {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .delete-box {
    padding: 2rem 4rem;
    background-color: rgb(33, 33, 49);
    border-radius: 1rem;
    width: 500px;
    text-align: center;
    img{
      width: 250px;
      margin-bottom: 1rem;
    }
    p{
      color: white;
    }
    .buttons{
      display: flex;
      padding-top: 2rem;

      gap: 9rem;
    }
    .BaseButton {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
